import { type KeyboardEvent, useState } from 'react'

import InboxIcon from '@mui/icons-material/Inbox'
import SearchIcon from '@mui/icons-material/Search'
import SettingsInputSvideoIcon from '@mui/icons-material/SettingsInputSvideo'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import TextField from '@mui/material/TextField'

import { Link } from '../../router/components/Link'
import { useNavigate } from '../../router/hooks/useNavigate'
import { useSearchbar } from '../hooks/useSearchbar'

export function Searchbar() {
  const navigate = useNavigate()
  const [selectedIndex, setSelectedIndex] = useState(0)
  const { data, isLoading, search, setSearch } = useSearchbar()

  function onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault()

      if (data.length > 0) {
        const option = data[selectedIndex]
        const link =
          option.type === 'Aanvraag'
            ? `/aansluiting/project/${option.aanvraagID}`
            : `/hoofdleiding/project/${option.aanvraagID}`

        navigate(link)
      }
    } else if (event.key === 'ArrowDown') {
      event.preventDefault()

      setSelectedIndex((prev) => (prev < data.length - 1 ? prev + 1 : prev))
    } else if (event.key === 'ArrowUp') {
      event.preventDefault()

      setSelectedIndex((prev) => (prev > 0 ? prev - 1 : 0))
    }
  }

  return (
    <Autocomplete
      sx={{ maxWidth: '600px', width: '100%' }}
      options={data}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : option.aanvraagID
      }
      inputValue={search}
      onInputChange={(_, newInputValue) => {
        setSearch(newInputValue)
      }}
      open={data.length > 0}
      freeSolo
      disableClearable
      slotProps={{
        paper: { sx: { borderRadius: '20px' } },
        popper: { sx: { zIndex: 1100 } },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Snel zoeken op project id..."
          autoFocus
          onKeyDown={onKeyDownHandler}
          slotProps={{
            ...params.slotProps,

            input: {
              ...params.slotProps.input,
              sx: {
                height: '40px',
                borderRadius: '20px',
                background: 'white',
              },
              endAdornment: isLoading ? (
                <CircularProgress size={24} />
              ) : (
                <SearchIcon />
              ),
            },
          }}
        />
      )}
      renderOption={(_, option, { index }) => {
        const isSelected = index === selectedIndex

        return (
          <ListItem
            key={option.aanvraagID}
            disableGutters
            disablePadding
            aria-selected={isSelected}
            sx={{
              backgroundColor: isSelected ? 'rgba(0, 0, 0, 0.08)' : 'inherit',
            }}
          >
            <ListItemButton
              component={Link}
              to={
                option.type === 'Aanvraag'
                  ? `/aansluiting/project/${option.aanvraagID}`
                  : `/hoofdleiding/project/${option.aanvraagID}`
              }
            >
              <ListItemIcon>
                {option.type === 'Aanvraag' ? (
                  <InboxIcon />
                ) : (
                  <SettingsInputSvideoIcon />
                )}
              </ListItemIcon>
              <ListItemText
                primary={
                  // @ts-expect-error naam exists on hoofdleiding
                  option.aanvraagID + (option.naam ? ` - ${option.naam}` : '')
                }
                secondary={option.statusText}
              />
            </ListItemButton>
          </ListItem>
        )
      }}
    />
  )
}
